import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapDateTime = React.lazy(function () {
    return import('../../bootstrap-components/components/BTDateTimePicker');
});
var handleChange = function (props) {
    {
        props;
    }
    console.log('onBlur of DateTime picker is called');
};
var bootStrapDateTime = function (props) {
    return (React.createElement(BootStrapDateTime, __assign({}, props, { disabled: props.disabled, styleName: props.hasError ? 'danger' : props.styleName, onBlur: props.onBlur, maxDate: props.maxDate, minDate: props.minDate })));
};
var DateTimePicker = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapDateTime(props);
            break;
        default:
            componentToDisplay = bootStrapDateTime(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
DateTimePicker.defaultProps = {
    styleName: 'primary',
    name: 'DateTimePicker',
    ioTheme: themes[0],
    ioMode: 'light',
    isInlineGridComponent: false
};
export default DateTimePicker;
//# sourceMappingURL=DateTimePicker.js.map